module.exports = __webpack_public_path__ + "img/coupon-item-choose-ico-rtl.2ddf2f3c.png";